// extracted by mini-css-extract-plugin
export default {"divTextToHome":"VerifyEmail_divTextToHome__KPWbY","iconBack":"VerifyEmail_iconBack__htHGW"};